import { FC } from 'react';

import { Wallet } from 'types/copyTrading';

import { WalletItem } from './components/WalletItem';
import * as S from './WalletsFound.styles';

interface WalletsFoundProps {
  wallets: Wallet[];
  onWalletClick?: (wallet: Wallet) => void;
}

export const WalletsFound: FC<WalletsFoundProps> = ({ wallets, onWalletClick }) => {
  return (
    <S.Container>
      <S.List>
        {wallets.map((wallet) => (
          <WalletItem
            key={wallet.address}
            address={wallet.address}
            roi={wallet.roi}
            onClick={() => onWalletClick?.(wallet)}
          />
        ))}
      </S.List>
      <S.Total>
        Wallets Found: <span>{wallets.length}</span>
      </S.Total>
    </S.Container>
  );
};
